exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table[data-v-21459744]{width:100%;position:relative}.table .cln-numero[data-v-21459744]{width:90px;min-width:90px}.table .cln-civilite[data-v-21459744]{width:120px;min-width:120px}.table .cln-nom-prenom[data-v-21459744]{width:400px;min-width:400px}.table .cln-nom-naissance[data-v-21459744]{width:250px;min-width:250px}.table .cln-action[data-v-21459744]{width:150px;min-width:150px}.table .tbody[data-v-21459744]{height:400px}.table .tbody .cln-check[data-v-21459744]{cursor:pointer;transition-property:background-color;transition-duration:.2s}.table .tbody .cln-check[data-v-21459744]:hover{background-color:#d0f6ec}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-21459744","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/modalComponents/modalPropositionsEntreeSalarie/modalPropositionsEntreeSalarie.scss
// module id = bgcO
// module chunks = 2